const DECIMAL_REGEX = /^\d+(\.\d{1,2})?$/;

export const isTwoDigitsAfterDecimal = (value: number | undefined) =>
  value ? DECIMAL_REGEX.test(`${value}`) : true;
